import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import { fetchPagIbigRequest } from "../../../api/pagIbig";
import { formatCurrency } from "../../../helpers/functions/currency.js";
import moment from "moment";

class PagIbigDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null,
                salaryFrom: null,
                salaryTo: null,
                employerShare: null,
                employeeShare: null,
                totalContribution: null,
                effectiveDate: null,
                createdAt: null,
                updatedAt: null
            }
        }
    }

    componentDidMount() {
        const { instanceId } = this.props;
        if(instanceId) {
            this.fetchPagIbig(instanceId)
        }
    }

    fetchPagIbig = (id) => {
        fetchPagIbigRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    render() {

        const { 
            _id, 
            salaryFrom,
            salaryTo,
            employerShare,
            employeeShare,
            totalContribution,
            effectiveDate,
            createdAt, 
            updatedAt
          } = this.state.resource;

        return (
            <Grid fluid>
                <div className="form-header">
                    <h3 className="text-secondary font-weight-bold">
                        Pag-Ibig Instance Details
                    </h3>
                    <Button className="btn btn-primary top-btn" onClick={() => this.props.goToList('pag-ibig')}>Back to list</Button>
                </div>
                <Row>
                    <Col md={12}>
                        <div className="typo-line">
                            <div>
                            <p className="category">Instance ID</p>
                            {_id || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Salary From</p>
                            {formatCurrency(salaryFrom) || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Salary To</p>
                            {formatCurrency(salaryTo) || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Employer Share</p>
                            {formatCurrency(employerShare) || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Employee Share</p>
                            {formatCurrency(employeeShare) || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Total Contribution</p>
                            {formatCurrency(totalContribution) || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Effective Date</p>
                            {effectiveDate ? moment(effectiveDate).format('MM/DD/YYYY') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Created At</p>
                            {createdAt ? moment(createdAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Updated At</p>
                            {updatedAt ? moment(updatedAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <Button className="btn btn-primary bottom-btn" onClick={() => this.props.goToEditForm('pag-ibig', _id)}>Edit</Button>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default PagIbigDetails;
